<template>
  <v-container fluid>
    <v-toolbar dense flat>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn icon @click="showKontaktNeu = true" v-on="on"><v-icon>add</v-icon></v-btn>
        </template>
        <span>Erstellen</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn class="hidden-sm-and-down" icon @click="showMehrereBearbeiten = true" v-on="on"
            ><v-icon>edit_note</v-icon></v-btn
          >
        </template>
        <span>Auswahl bearbeiten</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn class="hidden-sm-and-down" icon v-on="on" @click.stop="showImportExport = !showImportExport"
            ><v-icon>cloud_upload</v-icon></v-btn
          >
        </template>
        <span>Daten importieren</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn class="hidden-sm-and-down" icon v-on="on" @click="exportData()"><v-icon>cloud_download</v-icon></v-btn>
        </template>
        <span>Daten exportieren</span>
      </v-tooltip>

      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn
            icon
            @click="
              showPrintDialog = true;
              printData = {};
            "
            v-on="on"
            ><v-icon>print</v-icon></v-btn
          >
        </template>
        <span>Drucken</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn class="hidden-sm-and-down" icon @click="showAenderungen = true" v-on="on"
            ><v-icon>manage_accounts</v-icon></v-btn
          >
        </template>
        <span>Kontaktänderungen</span>
      </v-tooltip>
      <v-spacer></v-spacer>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn class="hidden-sm-and-down" icon @click="showFilterSpalten = true" v-on="on"
            ><v-icon>tune</v-icon></v-btn
          >
        </template>
        <span>Spalten</span>
      </v-tooltip>
      <v-toolbar-items>
        <v-text-field
          v-model="search"
          append-icon="search"
          label="Suchen"
          single-line
          solo
          flat
          hide-details
          clearable
          clear-icon="close"
        ></v-text-field>
      </v-toolbar-items>
    </v-toolbar>
    <v-divider></v-divider>

    <!-- ***************************************************************** 

Import von Kontakten

***************************************************************** -->

    <dialogImportKontakte v-if="showImportExport" :visible="showImportExport" @close="showImportExport = false" />

    <!-- ***************************************************************** 

Tabelle mit Bundesbrüdern

***************************************************************** -->
    <v-navigation-drawer
      :v-model="showVarGruppenLeiste"
      app
      right
      :clipped="$vuetify.breakpoint.lgAndUp"
      :mini-variant.sync="showGruppenLeiste"
    >
      <v-list dense>
        <v-list-item>
          <v-list-item-icon>
            <v-icon v-if="showGruppenLeiste" @click.stop="showGruppenLeiste = !showGruppenLeiste"
              >keyboard_arrow_left</v-icon
            >
            <v-icon v-else @click.stop="showGruppenLeiste = !showGruppenLeiste">keyboard_arrow_right</v-icon>
          </v-list-item-icon>
          <v-list-item-title class="subtitle-1">Gruppen</v-list-item-title>
        </v-list-item>
        <v-divider></v-divider>
        <v-list-item link @click="(selectedGruppe = null) && (selected = [])">
          <v-tooltip left>
            <template v-slot:activator="{ on }">
              <v-list-item-icon v-on="on">
                <v-icon>groups</v-icon>
              </v-list-item-icon>
            </template>
            <span>Alle Kontakte</span>
          </v-tooltip>
          <v-list-item-content>
            <v-list-item-title>Alle Kontakte</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link @click="setSelectedGruppeBbrBbr()">
          <v-tooltip left>
            <template v-slot:activator="{ on }">
              <v-list-item-icon v-on="on">
                <v-icon>groups</v-icon>
              </v-list-item-icon>
            </template>
            <span>Alle {{ bezMitglieder }}</span>
          </v-tooltip>
          <v-list-item-content>
            <v-list-item-title>Alle {{ bezMitglieder }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-group :value="gruppe.expand" v-for="(gruppe, index) in gruppen.gruppen" :key="index">
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>{{ gruppe.titel }}</v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item
            nav
            v-for="(item, index2) in gruppe.gruppen"
            :key="index2"
            @click="(selectedGruppe = item) && (selected = [])"
          >
            <v-tooltip left>
              <template v-slot:activator="{ on }">
                <v-list-item-icon v-on="on">
                  <v-icon>group</v-icon>
                </v-list-item-icon>
              </template>
              <span>{{ item.text }}</span>
            </v-tooltip>
            <v-list-item-title>{{ item.text }}</v-list-item-title>
          </v-list-item>
        </v-list-group>
      </v-list>
    </v-navigation-drawer>

    <v-row class="ma-0 pa-0">
      <v-col cols="12">
        <v-card outlined>
          <v-data-iterator
            dense
            height="calc(100vh - 300px)"
            :headers="headers"
            :items="bbrbbr"
            :search="search"
            fixed-header
            hide-default-footer
            :hide-default-header="$vuetify.breakpoint.xsOnly"
            :items-per-page="-1"
            no-data-text="Keine Kontakte vorhanden"
            class="hidden-sm-and-up"
          >
            <template v-slot:item="{ item }">
              <v-list-item @click="(bbr = item) && (showBbr = true)">
                <v-list-item-content>
                  <v-list-item-title>
                    <span v-if="item.titel" class="mr-1">{{ item.titel }}</span
                    >{{ item.nachname }}, {{ item.vorname }}
                  </v-list-item-title>
                  <v-list-item-subtitle class="subtitle-2">
                    {{ item.status }}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-divider></v-divider>
            </template>
          </v-data-iterator>

          <v-data-table
            height="calc(100vh - 300px)"
            :headers="headers"
            :items="bbrbbr"
            :search="search"
            fixed-header
            :items-per-page="50"
            :footer-props="{
              'items-per-page-options': [50, 100, 250, -1],
              'items-per-page-text': 'Kontakte pro Seite',
            }"
            show-select
            single-select
            :hide-default-header="hideHeader"
            no-data-text="Keine Kontakte vorhanden"
            dense
            class="hidden-xs-only"
          >
            <template v-slot:footer.page-text="items">
              {{ items.pageStart }} - {{ items.pageStop }} von {{ items.itemsLength }}
            </template>
            <template v-slot:top>
              <v-row no-gutters class="py-2 px-4">
                <v-col cols="12">
                  <span class="title" v-if="selectedGruppe !== null"
                    >{{ selectedGruppe.text }} (<span v-if="selected.length > 0">{{ selected.length }}/</span
                    >{{ bbrbbr.length }})</span
                  >
                  <span class="title" v-else
                    >Alle Kontakte (<span v-if="selected.length > 0">{{ selected.length }}/</span
                    >{{ bbrbbr.length }})</span
                  >
                </v-col>
              </v-row>
              <v-divider></v-divider>
            </template>
            <template v-slot:header="{ item }">
              <tr class="hidden-sm-and-up">
                <th></th>
                <th>Bundesbruder</th>
                <th></th>
              </tr>
            </template>
            <template v-slot:header.data-table-select="{ item }">
              <th>
                <v-btn v-if="selected.length === 0" icon @click="addSelect('alle')"
                  ><v-icon>check_box_outline_blank</v-icon></v-btn
                >
                <v-btn v-if="selected.length !== 0 && selected.length !== bbrbbr.length" icon @click="addSelect('alle')"
                  ><v-icon>indeterminate_check_box</v-icon></v-btn
                >
                <v-btn v-if="selected.length === bbrbbr.length" icon @click="addSelect('keine')"
                  ><v-icon>check_box</v-icon></v-btn
                >
              </th>
            </template>
            <template v-slot:item="{ item }">
              <tr
                v-on:dblclick="(bbr = item) && (showBbr = true)"
                :class="['Ausgetreten', 'Verstorben'].indexOf(item.status) !== -1 ? 'grey--text grey lighten-4' : ''"
              >
                <td width="20px" v-if="checkIndex(item.id)" class="pr-0">
                  <v-btn icon @click="addSelect(item.id)"><v-icon>check_box_outline_blank</v-icon></v-btn>
                </td>
                <td width="20px" v-else class="pr-0">
                  <v-btn icon @click="addSelect(item.id)"><v-icon>check_box</v-icon></v-btn>
                </td>
                <td v-for="(item2, index) in headers" :key="index">
                  <span v-if="item2.item.type === 'Date'">{{ $filters.date(item[item2.value], "DD.MM.YYYY") }}</span>
                  <span v-else-if="item2.item.type === 'Gruppen'">
                    <v-chip
                      label
                      small
                      class="ma-1"
                      v-for="(gruppe, gruppeindex) in item[item2.value]"
                      :key="gruppeindex"
                      >{{ gruppe }}</v-chip
                    >
                  </span>
                  <span v-else-if="item2.item.type === 'Leibvater'">{{
                    $filters.user(item[item2.value], bbrbbr2)
                  }}</span>
                  <span v-else-if="item2.item.type === 'Verbindung'">{{ item[item2.value] }}</span>
                  <span v-else-if="item2.item.type === 'Verbindungen'">
                    <v-chip label small class="ma-1" v-for="(ver, verindex) in item[item2.value]" :key="verindex">{{
                      ver
                    }}</v-chip>
                  </span>
                  <span v-else>{{ item[item2.value] }}</span>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>

    <!-- ***************************************************************** 

Dialog einzelner Bundesbruder

***************************************************************** -->

    <dialogKontaktCreate
      v-if="showKontaktNeu"
      :visible.sync="showKontaktNeu"
      @close="showKontaktNeu = false"
    ></dialogKontaktCreate>
    <dialogKontaktEdit
      v-if="showBbr"
      :visibleEdit.sync="showBbr"
      :visible.sync="showBbr"
      :bbr="bbr"
      @close="showBbr = false"
    ></dialogKontaktEdit>
    <dialogKontaktEditMultiple
      v-if="showMehrereBearbeiten"
      :visible.sync="showMehrereBearbeiten"
      :selectedKontakte="selected"
      @close="showMehrereBearbeiten = false"
    ></dialogKontaktEditMultiple>

    <v-dialog
      v-model="showPrintDialog"
      v-if="showPrintDialog"
      width="80%"
      :fullscreen="$vuetify.breakpoint.smAndDown"
      persistent
      scrollable
    >
      <v-card min-height="600px">
        <v-card-title>
          Druck vorbereiten
          <v-spacer></v-spacer>
          <v-btn icon @click="showPrintDialog = false"><v-icon>close</v-icon></v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pb-0">
          <v-row>
            <v-col cols="12" md="6">
              Welche Kontakte sollen gedruckt werden?
              <v-radio-group v-model="printData.radioKontakte">
                <v-radio :label="'Alle Ausgewählten Kontakte (' + selected.length + ')'" value="allSelected"></v-radio>
                <v-radio value="allStatus">
                  <template v-slot:label>
                    Kontakte nach Status<v-select
                      v-model="printData.gruppen"
                      dense
                      class="ml-2"
                      single-line
                      outlined
                      hide-details
                      small-chips
                      chips
                      clearable
                      deletable-chips
                      multiple
                      :items="itemsStatus"
                      label="Hier auswählen"
                    ></v-select>
                  </template>
                </v-radio>
                <v-radio :label="'Alle ' + bezMitglieder" value="allBbrBbr"></v-radio>
                <v-radio label="Alle Kontakte" value="all"></v-radio>
              </v-radio-group>
            </v-col>
            <v-col cols="12" md="6">
              Was willst du drucken?
              <v-radio-group v-model="printData.druckelement">
                <v-radio value="mitgliederverzeichnis">
                  <template v-slot:label>
                    <v-list dense class="py-0">
                      <v-list-item link>
                        <v-list-item-content class="py-0">
                          <v-list-item-title>Mitgliederverzeichnis </v-list-item-title>
                          <v-list-item-subtitle>Geburtstagsliste und Kontaktdaten</v-list-item-subtitle>
                          <v-list-item-subtitle>PDF, A5</v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </template>
                </v-radio>
                <v-radio value="geburtstagsliste">
                  <template v-slot:label>
                    <v-list dense class="py-0">
                      <v-list-item link>
                        <v-list-item-content class="py-0">
                          <v-list-item-title>Geburtstagsliste</v-list-item-title>
                          <v-list-item-subtitle
                            >Geburtstagsliste, zwei Dateien für Sommer- und Wintersemester</v-list-item-subtitle
                          >
                          <v-list-item-subtitle>PDF, A4</v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </template>
                </v-radio>
                <v-radio value="versandadressendina4">
                  <template v-slot:label>
                    <v-list dense class="py-0">
                      <v-list-item link>
                        <v-list-item-content class="py-0">
                          <v-list-item-title>Versandadressen DIN A4</v-list-item-title>
                          <v-list-item-subtitle>Briefumschlaf DIN A4 mit Fenster</v-list-item-subtitle>
                          <v-list-item-subtitle>PDF A4, jeweils 1 Adresse pro Blatt</v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </template>
                </v-radio>
                <v-radio value="versandadressendina4mitAnschreiben">
                  <template v-slot:label>
                    <v-list dense class="py-0">
                      <v-list-item link>
                        <v-list-item-content class="py-0">
                          <v-list-item-title>Versandadressen DIN A4 mit Anschreiben</v-list-item-title>
                          <v-list-item-subtitle>Briefumschlaf DIN A4 mit Fenster</v-list-item-subtitle>
                          <v-list-item-subtitle
                            >PDF A4, jeweils 1 Adresse pro Blatt, dadrunter Anschreiben</v-list-item-subtitle
                          >
                          <v-btn
                            v-if="printData.druckelement === 'versandadressendina4mitAnschreiben'"
                            outlined
                            small
                            class="my-2"
                            @click="showAnschreiben = true"
                            >Anschreiben bearbeiten</v-btn
                          >
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </template>
                </v-radio>
                <v-radio value="versandadressendinlang">
                  <template v-slot:label>
                    <v-list dense class="py-0">
                      <v-list-item link>
                        <v-list-item-content class="py-0">
                          <v-list-item-title>Versandadressen DIN Lang</v-list-item-title>
                          <v-list-item-subtitle>Briefumschlaf DIN Lang mit Fenster</v-list-item-subtitle>
                          <v-list-item-subtitle>PDF A4, jeweils 3 Adressen pro Blatt</v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </template>
                </v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="mb-6 mb-md-0">
          <v-btn text @click="showPrintDialog = false">Abbrechen</v-btn>
          <v-spacer></v-spacer>
          <v-btn
            text
            @click="print()"
            :loading="$vars.loading"
            :disabled="printData.radioKontakte === undefined || printData.druckelement === undefined"
            class="primary"
            >PDF erstellen</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="showAnschreiben"
      v-if="showAnschreiben"
      width="90%"
      :fullscreen="$vuetify.breakpoint.smAndDown"
      persistent
      scrollable
    >
      <v-card min-height="500px">
        <v-card-title>
          Anschreiben bearbeiten
          <v-spacer></v-spacer>
          <v-btn icon @click="showAnschreiben = false"><v-icon>close</v-icon></v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-text-field
          outlined
          dense
          hide-details
          v-model="printData.anschreibenTitel"
          class="pa-2"
          placeholder="Titel eingeben"
        ></v-text-field>
        <v-textarea
          outlined
          dense
          hide-details
          v-model="printData.anschreiben"
          rows="15"
          class="pa-2"
          placeholder="Anschreiben eingeben"
        ></v-textarea>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="showAnschreiben = false">Speichern</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="showAenderungen"
      v-if="showAenderungen"
      width="90%"
      :fullscreen="$vuetify.breakpoint.smAndDown"
      persistent
      scrollable
    >
      <v-card min-height="500px">
        <v-card-title>
          Änderungen an den Mitgliederdaten
          <v-spacer></v-spacer>
          <v-btn icon @click="showAenderungen = false"><v-icon>close</v-icon></v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-tabs centered v-model="jahrSelect" center-active>
          <v-tab v-for="(jahr, index) in jahre" :key="index">
            {{ jahr }}
          </v-tab>
        </v-tabs>
        <v-tabs grow v-model="monatSelect">
          <v-tab v-for="(monat, index) in monate" :key="index">
            {{ $filters.date(jahre[jahrSelect] + "-" + monat, "MM") }}
          </v-tab>
        </v-tabs>
        <v-divider></v-divider>
        <v-card-text class="pa-0">
          <v-simple-table dense fixed-header height="calc(90vh - 266px)">
            <thead>
              <tr>
                <th></th>
                <th>Geänderter Kontakt</th>
                <th>Geändert durch</th>
                <th>Geändert am</th>
                <th>Geänderte Felder</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td
                  colspan="5"
                  class="py-3 text-center"
                  v-if="bearbeitungen[jahre[jahrSelect]][monate[monatSelect]] === undefined"
                >
                  Im {{ $filters.date(jahre[jahrSelect] + "-" + monate[monatSelect], "MMMM YYYY") }} wurden keine
                  Änderungen vorgenommen.
                </td>
              </tr>

              <tr v-for="(item, index) in bearbeitungen[jahre[jahrSelect]][monate[monatSelect]]" :key="index">
                <td width="20px">{{ index + 1 }}</td>
                <td>{{ $filters.user(item.elementId, bbrbbr2) }}</td>
                <td>{{ $filters.user(item.dataNeu.zuletztGeaendertVon, bbrbbr2) }}</td>
                <td>{{ $filters.date(item.dataNeu.zuletztGeaendertAm, "DD.MM.YYYY hh:mm") }} Uhr</td>
                <td>
                  <v-tooltip bottom v-for="(item2, index2) in item.anders" :key="item2">
                    <template v-slot:activator="{ on }">
                      <v-chip small v-on="on">{{ item2 }}</v-chip>
                    </template>
                    <v-simple-table dense dark class="transparent">
                      <thead>
                        <tr>
                          <th>von</th>
                          <th>zu</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td v-if="item.dataAlt[item2] instanceof Object">
                            <div v-for="(text, index2) in item.dataAlt[item2]" :key="index2">
                              <v-chip label small class="mt-1">
                                {{ text }}
                              </v-chip>
                            </div>
                          </td>
                          <td v-else>{{ item.dataAlt[item2] ? item.dataAlt[item2] : "-" }}</td>
                          <td v-if="item.dataNeu[item2] instanceof Object">
                            <div v-for="(text, index3) in item.dataNeu[item2]" :key="index3">
                              <v-chip label small class="mt-1">
                                {{ text }}
                              </v-chip>
                            </div>
                          </td>
                          <td v-else>{{ item.dataNeu[item2] ? item.dataNeu[item2] : "-" }}</td>
                        </tr>
                      </tbody>
                    </v-simple-table>
                  </v-tooltip>
                </td>
              </tr>
            </tbody>
          </v-simple-table>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="showAenderungen = false">Schließen</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="showFilterSpalten"
      v-if="showFilterSpalten"
      width="40%"
      :fullscreen="$vuetify.breakpoint.smAndDown"
      persistent
      scrollable
    >
      <v-card>
        <v-card-title>
          Spalten bearbeiten
          <v-spacer></v-spacer>
          <v-btn icon @click="showFilterSpalten = false"><v-icon>close</v-icon></v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-autocomplete
            chips
            deletable-chips
            small-chips
            @change="savereihenfolge"
            class="mt-2"
            hide-details
            outlined
            multiple
            dense
            label="Spalten auswählen"
            v-model="selectHeaders"
            :items="kontaktfelder_system"
          ></v-autocomplete>
          <v-list>
            <draggable v-model="selectHeaders" @change="savereihenfolge">
              <v-list-item class="py-0" v-for="(item, index) in selectHeaders" :key="index">
                <v-list-item-action class="my-0"><v-icon class="grey--text">drag_indicator</v-icon></v-list-item-action>
                <v-list-item-content class="my-0">
                  <v-list-item-title>{{
                    kontaktfelder_system.find((feld) => feld.value === item).text
                  }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </draggable>
          </v-list>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="showFilterSpalten = false">Schließen</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="showUpdate"
      v-if="showUpdate"
      width="40%"
      :fullscreen="$vuetify.breakpoint.smAndDown"
      persistent
      scrollable
    >
      <v-card>
        <v-card-title> Kontakte updaten </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="mt-4">
          <v-progress-linear stream rounded height="24" :value="(updatedItems / allItems) * 100">
            {{ updatedItems }} von {{ allItems }}
          </v-progress-linear>
          <v-alert type="warning" v-if="updateData.error.length > 0">
            {{ updateData.error }}
          </v-alert>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="showUpdate = false">Schließen</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
  import JSPDF from "jspdf";
  import draggable from "vuedraggable";
  import papa from "papaparse";
  import dialogImportKontakte from "./submodule/dialogImportKontakte";
  export default {
    props: ["filterStatus"],
    components: {
      draggable,
      dialogImportKontakte,
    },
    data() {
      return {
        search: "",
        updatedItems: 0,
        allItems: 0,
        sideNav: true,
        singleSelect: false,
        selected: [],
        e1: 1,
        monatSelect: "",
        jahrSelect: "",
        jahre: [],
        updateData: { error: [] },
        monate: ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"],
        bundesbruder: [],
        showKontaktNeu: false,
        showDeleteKontakt: false,
        bbrNeu: [],
        fehlerSepa: "",
        bbrImport: [],
        bbrUpdate: [],
        bbrNichtImport: [],
        bbrImportDoppelt: [],
        bbrNeuFelder: [],
        übernahmeItems: ["Nicht importieren", "Original updaten", "Neuer Kontakt"],
        csvDatei: [],
        json: [],
        showUpdate: false,
        showFilterSpalten: false,
        showGruppenLeiste: false,
        showVarGruppenLeiste: true,
        selectedGruppe: null,
        showImportExport: false,
        showAenderungen: false,
        bearbeiteteFelder: {
          sepa: {},
        },
        showMehrereBearbeiten: false,
        selectHeaders: ["nachname", "vorname", "status", "ort"],
        itemsZirkel: [
          "Aachen",
          "Berlin",
          "Bonn/Köln",
          "Düsseldorf/Neuss",
          "Essen",
          "Koblenz",
          "München",
          "Niederrhein",
        ],
        kontaktfelder: [],
        selectVerbindung: [
          "V.K.Th. Burgundia im Albertinum",
          "AV Alania Stuttgart",
          "AV Alsatia Münster",
          "AV Cheruscia Münster",
          "AV Cheruskia Tübingen",
          "AV Frisia Hannover",
          "AV Glückauf-Salia Clausthal-Zellerfeld",
          "AV Guestfalia Tübingen",
          "AV Hansea (Berlin) Köln",
          "AV Palatia Göttingen",
          "AV Rheinstein Köln",
          "AV Rheno-Guestfalia Kiel",
          "AV Salia-Silesia Gleiwitz",
          "AV Silesia (Halle, Bonn) Bochum",
          "AV Sparrenberg Bielefeld",
          "AV Suebo-Danubia Ulm",
          "AV Tuisconia (Königsberg, Bonn) Landshut",
          "AV Widukind Osnabrück",
          "AV Zollern Münster",
          "CV-Verbindung Rheno-Palatia (Breslau) Mainz",
          "FAV Rheno-Guestfalia (Hann. Münden) Göttingen",
          "KAV Capitolina Rom",
          "KAV Suevia Berlin",
          "KDStV Adolphiana Fulda",
          "KDStV Aenania München",
          "KDStV Agilolfia Freising",
          "KDStV Alania Bonn",
          "KDStV Alcimonia Eichstätt",
          "KDStV Alemannia Greifswald und Münster",
          "KDStV Algovia Augsburg",
          "KDStV Angrivaria (Sarstedt, Hannover) Dortmund",
          "KDStV Arminia Freiburg im Breisgau",
          "KDStV Arminia Heidelberg",
          "KDStV Ascania Bonn",
          "KDStV Asgard (Düsseldorf) Köln",
          "KDStV Aureo-Danubia Ingolstadt",
          "KDStV Badenia (Straßburg) Frankfurt am Main",
          "KDStV Baltia (Danzig) Aachen",
          "KDStV Bavaria Berlin",
          "KDStV Bavaria Bonn",
          "KDStV Bergisch-Thuringia Wuppertal",
          "KDStV Bergland (Freiberg) Aachen",
          "KDStV Bodensee Konstanz",
          "KDStV Borusso-Saxonia Berlin",
          "KDStV Borusso-Westfalia Bonn",
          "KDStV Burgundia (Leipzig) Düsseldorf",
          "KDStV Burgundia München",
          "KDStV Carolingia Hohenheim",
          "KDStV Carolus Magnus Saarbrücken",
          "KDStV Cheruscia Würzburg",
          "KDStV Churpfalz Mannheim",
          "KDStV Chursachsen Dresden",
          "KDStV Churtrier Trier",
          "KDStV Elbmark (Tetschen-Liebwerd) Duisburg",
          "KDStV Falkenstein Freiburg im Breisgau",
          "KDStV Ferdinandea (Prag) Heidelberg",
          "KDStV Franco-Raetia Würzburg",
          "KDStV Franconia Aachen",
          "KDStV Frankonia (Czernowitz) Erlangen",
          "KDStV Fredericia Bamberg",
          "KDStV Germania Leipzig",
          "KDStV Gothia Erlangen",
          "KDStV Gothia Würzburg",
          "KDStV Greiffenstein (Breslau) Frankfurt",
          "KDStV Guestfalo-Silesia Paderborn",
          "KDStV Hasso-Nassovia Frankfurt am Main",
          "KDStV Hercynia Freiburg im Breisgau",
          "KDStV Hohenstaufen Freiburg im Breisgau",
          "KDStV Kaiserpfalz Aachen",
          "KDStV Langobardia (München) Bayreuth",
          "KDStV Makaria (Berlin) Aachen",
          "KDStV Marchia (Breslau) Aachen",
          "KDStV Markomannia Würzburg",
          "KDStV Merowingia Kaiserslautern",
          "KDStV Moenania München",
          "KDStV Moeno-Franconia Frankfurt am Main",
          "KDStV Nassovia Darmstadt",
          "KDStV Nibelungia (Brünn) Darmstadt",
          "KDStV Niedersachsen Braunschweig",
          "KDStV Norbertina Magdeburg",
          "KDStV Nordgau (Prag, Stuttgart) Koblenz",
          "KDStV Nordmark (Rostock, Karlsruhe) Essen",
          "KDStV Normannia Karlsruhe",
          "KDStV Novesia Bonn",
          "KDStV Oeno-Danubia Passau",
          "KDStV Ostmark Nürnberg",
          "KDStV Palatia Marburg",
          "KDStV Palatina Amberg/Weiden",
          "KDStV Radaspona (Regensburg) München",
          "KDStV Rappoltstein (Straßburg) Köln",
          "KDStV Rheinland Köln",
          "KDStV Rheinpfalz Darmstadt",
          "KDStV Rhenania-Moguntia Mainz",
          "KDStV Rheno-Baltia Köln",
          "KDStV Rheno-Franconia München",
          "KDStV Rheno-Saxonia (Köthen) Halle",
          "KDStV Ripuaria Aachen",
          "KDStV Ripuaria Bonn",
          "KDStV Ripuaria Freiburg im Breisgau",
          "KDStV Rupertia Regensburg",
          "KDStV Saarland (Saarbrücken) Jena",
          "KDStV Sauerlandia Münster",
          "KDStV Saxo-Silesia Hannover",
          "KDStV Saxo-Thuringia (Dresden, Aachen) Bochum",
          "KDStV Schwarzwald Karlsruhe",
          "KDStV Seraphina Lippstadt",
          "KDStV Staufia Bonn",
          "KDStV Sugambria (Jena) Göttingen",
          "KDStV Teuto-Rhenania Hannover",
          "KDStV Teutonia Freiburg im Üechtland",
          "KDStV Thuringia Würzburg",
          "KDStV Trifels München",
          "KDStV Tuiskonia München",
          "KDStV Vandalia (Prag) München",
          "KDStV Vasgovia Landau",
          "KDStV Vindelicia München",
          "KDStV Welfia Weingarten",
          "KDStV Wiking Hamburg",
          "KDStV Wildenstein Freiburg im Breisgau",
          "KDStV Winfridia (Breslau) Münster",
          "KStV Thuringia Coburg",
          "KTV Visurgis Bremen",
          "VKDSt Hasso-Rhenania Gießen",
          "VKDSt Hasso-Rhenania Mainz",
          "VKDSt Rhenania Marburg",
          "VKDSt Saxonia Münster",
        ],
        showBbr: false,
        bbr: "",
        itemsBriefanrede: [
          "Lieber Bundesbruder",
          "Sehr geehrter Cartellbruder",
          "Sehr geehrter Farbenbruder",
          "Sehr geehrter Herr",
          "Sehr geehrte Frau",
          "Sehr geehrte Damen und Herren",
        ],
        itemsAnrede: ["Herr", "Frau", "Familie"],
        active: 0,
        date: "",
        menu1: false,
        menu2: false,
        menu3: false,
        menu4: false,
        menu5: false,
        menu6: false,
        showBbrRechnung: false,
        selectRechnung: "",
        showBbrNachricht: false,
        selectNachricht: "",
        showPrintDialog: false,
        printData: {},
        showAnschreiben: false,
      };
    },
    computed: {
      bbrbbr2() {
        return this.$store.state.bbrbbr.bbrbbr;
      },
      bezMitglieder() {
        return this.$store.getters["einstellungen/einstellung"]("allgemein").bezMitglieder;
      },
      currentBbr() {
        return this.$getCurrentBbr();
      },
      gruppen() {
        return this.$store.getters["einstellungen/einstellung"]("gruppen");
      },
      kassen() {
        return this.$store.state.einstellungen.einstellungen.find((item) => item.id === "kassen");
      },
      headers() {
        let header = [];
        let saveHeader = this.$store.getters["einstellungen/einstellung"]("kontaktspalten");
        if (saveHeader && saveHeader[this.currentBbr]) {
          this.selectHeaders = saveHeader[this.currentBbr];
          saveHeader[this.currentBbr].forEach((item) => {
            header.push(this.kontaktfelder_system.find((feld) => feld.value === item));
          });
          return header;
        } else {
          return [
            { item: { type: "String" }, text: "Vorname", align: "start", value: "vorname" },
            { item: { type: "String" }, text: "Nachname", align: "start", value: "nachname" },
            { item: { type: "String" }, text: "Ort", align: "start", value: "ort" },
            { item: { type: "String" }, text: "Status", align: "start", value: "status" },
          ];
        }
      },
      kontaktfelder_system() {
        let items = [];
        this.$store.getters["einstellungen/einstellung"]("kontaktfelder").neuFelder.forEach((item) => {
          items.push({
            text: item.label,
            value: item.value,
            item,
          });
        });
        items.push({
          text: "IBAN",
          value: "iban",
          item: {
            breite: 6,
            default: true,
            label: "IBAN",
            required: true,
            show: false,
            type: "String",
            value: "iban",
          },
        });
        return items;
      },
      bbrbbrKontaktImport() {
        let bbrbbr = [];
        this.$store.state.bbrbbr.bbrbbr.forEach((item) => {
          bbrbbr.push({
            text: item.nachname + ", " + item.vorname,
            value: item,
          });
        });
        return bbrbbr;
      },
      hideHeader() {
        return this.$vuetify.breakpoint.name === "xs";
      },
      itemsStatus() {
        let status = [];
        this.$store.getters["einstellungen/einstellung"]("mitgliederstatus").status.forEach((item) => {
          status.push(item.status);
        });
        return status;
      },
      bbrbbr() {
        if (!this.selectedGruppe) {
          return this.$store.state.bbrbbr.bbrbbr;
        }

        const { bedingungen } = this.selectedGruppe;
        const bbrbbrSet = new Set();

        this.$store.state.bbrbbr.bbrbbr.forEach((item) => {
          bedingungen.forEach(({ feld, wert }) => {
            const feldPfad = feld.split("."); // Split für geschachtelte Felder
            let itemValue = item;

            // Dynamisches Traversieren durch geschachtelte Objekte
            feldPfad.forEach((key) => {
              if (itemValue && typeof itemValue === "object") {
                itemValue = itemValue[key];
              } else {
                itemValue = undefined;
              }
            });

            if (!itemValue) return;

            const itemValues = Array.isArray(itemValue) ? itemValue : [itemValue];
            if (wert.some((value) => itemValues.includes(value))) {
              bbrbbrSet.add(item);
            }
          });
        });

        return Array.from(bbrbbrSet);
      },
      bearbeitungen() {
        if (this.$store.state.bearbeitungen.bearbeitungen.length === 0) {
          this.$store.dispatch("bearbeitungen/loadBearbeitungen");
        }
        let bearbeitungen = [];
        this.$store.state.bearbeitungen.bearbeitungen.forEach((item, index) => {
          let diff = [];
          for (const [key] of Object.entries(item.dataNeu)) {
            if (
              [
                // Felder die nicht angezeigt werden sollen
                "bildAhnengalerie200",
                "bildAhnengalerie500",
                "chargen",
                "geburtsjahr",
                "geburtsmonat",
                "geburtstag",
                "receptionsjahr",
                "receptionsmonat",
                "receptionstag",
                "x",
                "y",
                "alter",
                "anmeldeID",
                "id",
                "einstellungen",
                "notificationToken",
                "zuletztGeaendertAm",
                "zuletztGeaendertVon",
              ].indexOf(key) === -1
            ) {
              let val1 = item.dataNeu[key];
              let val2 = item.dataAlt[key];
              if (typeof val1 === "object" && typeof val2 === "object") {
                if (this.istGleichesObjekt(val1, val2)) {
                  diff.push(key);
                }
              } else {
                if (val1 !== val2) {
                  diff.push(key);
                }
              }
            }
          }
          item.anders = diff;
          if (item.dataNeu.zuletztGeaendertAm !== undefined) {
            bearbeitungen.push(item);
          }
        });
        let jahre = [];
        let ergebnis = {};
        let firstDate = Infinity;
        bearbeitungen.forEach((item) => {
          if (new Date(item.datum) < firstDate) {
            firstDate = new Date(item.datum);
          }
        });
        bearbeitungen.forEach((item) => {
          let jahr = new Date(item.datum).getFullYear();
          let monat = (new Date(item.datum).getMonth() + 1).toString().padStart(2, "0");
          if (ergebnis[jahr] === undefined) {
            ergebnis[jahr] = {};
            jahre.push(jahr);
          }
          if (ergebnis[jahr][monat] === undefined) {
            ergebnis[jahr][monat] = [];
          }
          if (item.anders.length > 0) {
            ergebnis[jahr][monat].push(item);
          }
        });
        this.jahre = jahre.sort((a, b) => {
          return a - b;
        });
        this.jahrSelect = jahre.indexOf(new Date().getFullYear());
        this.monatSelect = new Date().getMonth();
        return ergebnis;
      },
    },
    methods: {
      setSelectedGruppeBbrBbr() {
        let wert = [];
        this.$store.getters["einstellungen/einstellung"]("mitgliederstatus").status.forEach((item) => {
          if (item.mitglied) {
            wert.push(item.status);
          }
        });
        this.selectedGruppe = {
          bedingungen: [
            {
              feld: "status",
              wert,
            },
          ],
          text: "Alle " + this.bezMitglieder,
        };
      },
      istGleichesObjekt(obj1, obj2) {
        // Überprüfen, ob beide Objekte vom gleichen Typ sind
        if (obj1 === null) {
          return false;
        }
        if (obj2 === null) {
          return false;
        }
        if (typeof obj1 !== typeof obj2) {
          return false;
        }
        if (Object.keys(obj1).length === 0 && Object.keys(obj2).length === 0) {
          return false;
        }
        if (Object.keys(obj1).length !== Object.keys(obj2).length) {
          return true;
        }
        // Überprüfen, ob alle Eigenschaften in beiden Objekten gleich sind
        for (let prop in obj1) {
          if (obj1[prop] === obj2[prop]) {
            return false;
          }
        }
        return true;
      },
      bearbeiteMehrere() {
        this.showUpdate = true;
        var functions = this.$firebase.functions();
        let items = [];
        if (this.bearbeiteteFelder.alleBearbeiten === "true") {
          this.bbrbbr2.forEach((bbr) => {
            items.push(bbr.id);
          });
        } else {
          items = this.selected;
        }
        this.updatedItems = 0;
        this.allItems = items.length;
        items.forEach((id) => {
          let bbr = this.$store.getters["bbrbbr/bbr"](id);
          if (this.bearbeiteteFelder.anrede) {
            bbr.anrede = this.bearbeiteteFelder.anrede;
          }
          if (this.bearbeiteteFelder.briefanrede) {
            bbr.briefanrede = this.bearbeiteteFelder.briefanrede;
          }
          if (this.bearbeiteteFelder.urverbindung) {
            bbr.urverbindung = this.bearbeiteteFelder.urverbindung;
          }
          if (this.bearbeiteteFelder.zirkel) {
            bbr.zirkel = this.bearbeiteteFelder.zirkel;
          }
          if (this.bearbeiteteFelder.status) {
            bbr.status = this.bearbeiteteFelder.status;
          }
          if (this.bearbeiteteFelder.aktivenBeitrag) {
            bbr.aktivenBeitrag = this.bearbeiteteFelder.aktivenBeitrag;
          }
          if (this.bearbeiteteFelder.cvBeitrag) {
            bbr.cvBeitrag = this.bearbeiteteFelder.cvBeitrag;
          }
          if (this.bearbeiteteFelder.ahvBeitrag) {
            bbr.ahvBeitrag = this.bearbeiteteFelder.ahvBeitrag;
          }
          if (this.bearbeiteteFelder.hbvBeitrag) {
            bbr.hbvBeitrag = this.bearbeiteteFelder.hbvBeitrag;
          }
          if (this.bearbeiteteFelder.sepa_bearbeiten) {
            if (bbr.sepa === undefined) {
              bbr.sepa = {};
            }
            Object.keys(this.bearbeiteteFelder.sepa).forEach((key) => {
              if (this.bearbeiteteFelder.sepa[key] !== null) {
                bbr.sepa[key] = this.bearbeiteteFelder.sepa[key];
              }
            });
          }
          functions
            .httpsCallable("updateUser")({ user: bbr, verein: this.$vars.verbindung })
            .then((result) => {
              if (result.data.status) {
                this.updatedItems++;
                if (this.updatedItems === this.allItems) {
                  this.showUpdate = false;
                }
              } else {
                this.updateData.error.push(result.data);
              }
            })
            .catch((error) => {
              console.log(error);
            });
        });
        this.showMehrereBearbeiten = false;
      },
      checkIndex(id) {
        if (this.selected.indexOf(id) >= 0) {
          return false;
        } else {
          return true;
        }
      },
      addSelect(id) {
        if (id === "alle" || id === "keine") {
          this.selected = [];
          if (id === "alle") {
            this.bbrbbr.forEach((bbr) => {
              this.selected.push(bbr.id);
            });
          }
        } else {
          if (this.selected.indexOf(id) >= 0) {
            this.selected.splice(this.selected.indexOf(id), 1);
          } else {
            this.selected.push(id);
          }
        }
      },
      importInNeueBbr() {
        const fileToLoad = this.csvDatei;
        const reader = new FileReader();
        let bbrNeuFelder = [];
        let bbrNeu = [];
        let kontaktfelder = this.kontaktfelder;
        reader.onload = (fileLoadedEvent) => {
          papa.parse(fileLoadedEvent.target.result, {
            header: false,
            encoding: "ISO-8859-1",
            complete(results) {
              results.data[0].forEach((item) => {
                bbrNeuFelder.push(item);
              });
              bbrNeuFelder.forEach((item) => {
                kontaktfelder.forEach((feld) => {
                  if (feld.system === item) {
                    feld.importiert = item;
                  }
                  if (feld.text === item) {
                    feld.importiert = item;
                  }
                });
              });
            },
            error(errors) {
              console.log("error", errors);
            },
          });
          papa.parse(fileLoadedEvent.target.result, {
            header: true,
            encoding: "ISO-8859-1",
            complete(results) {
              results.data.forEach((item) => {
                bbrNeu.push(item);
              });
            },
            error(errors) {
              console.log("error", errors);
            },
          });
        };
        reader.readAsText(fileToLoad);
        this.e1 = 2;
        this.bbrNeuFelder = bbrNeuFelder;
        this.bbrNeu = bbrNeu;
      },
      wechselHeader() {
        // Ändern der Spaltenüberschriften
        let bbrImport = [];
        this.bbrNeu.forEach((item) => {
          let bbr = [];
          this.kontaktfelder.forEach((feld) => {
            if (item[feld.importiert]) {
              bbr[feld.system] = item[feld.importiert];
            } else {
              bbr[feld.system] = "";
            }
          });
          bbrImport.push(bbr);
        });
        // Schauen nach doppelten Kontakten
        let bbrbbr = this.bbrbbr;
        this.bbrImportDoppelt = [];
        bbrImport.forEach((item) => {
          bbrbbr.forEach((bbr) => {
            if (
              this.similarity(item.nachname, bbr.nachname) > 0.85 &&
              this.similarity(item.vorname, bbr.vorname) > 0.85
            ) {
              this.bbrImportDoppelt.push({
                original: bbr,
                importiert: item,
                übereinstimmung:
                  (
                    ((this.similarity(item.nachname, bbr.nachname) + this.similarity(item.vorname, bbr.vorname)) / 2) *
                    100
                  ).toFixed(2) + "%",
                übernehmen: "Nicht importieren",
              });
              console.log({
                original: bbr,
                importiert: item,
                übereinstimmung:
                  (
                    ((this.similarity(item.nachname, bbr.nachname) + this.similarity(item.vorname, bbr.vorname)) / 2) *
                    100
                  ).toFixed(2) + "%",
                übernehmen: "Nicht importieren",
              });
            }
          });
        });
        this.bbrImport = bbrImport;
        this.e1 = 3;
      },
      updateImportStatus(status) {
        this.bbrImportDoppelt.forEach((item) => {
          item.übernehmen = status;
        });
      },
      updateDoppelt() {
        this.bbrNichtImport = [];
        this.bbrUpdate = [];
        this.bbrImportDoppelt.forEach((item) => {
          if (item.übernehmen === "Nicht importieren") {
            this.bbrImport.splice(this.bbrImport.indexOf(item.importiert), 1);
            this.bbrNichtImport.push({
              item: item.importiert,
              id: item.original.id,
            });
          } else if (item.übernehmen === "Original updaten") {
            this.bbrImport.splice(this.bbrImport.indexOf(item.importiert), 1);
            this.bbrUpdate.push({
              item: item.importiert,
              id: item.original.id,
            });
          }
        });
        this.e1 = 4;
      },
      exportData() {
        var csv = papa.unparse(this.bbrbbr, { header: true, encoding: "UTF-8" });
        const anchor = document.createElement("a");
        anchor.href = "data:text/csv;charset=utf-8," + encodeURIComponent(csv);
        anchor.target = "_blank";
        anchor.download = this.selectedGruppe.text + ".csv";
        anchor.click();
      },
      similarity(s1, s2) {
        var longer = s1;
        var shorter = s2;
        if (s1.length < s2.length) {
          longer = s2;
          shorter = s1;
        }
        var longerLength = longer.length;
        if (longerLength === 0) {
          return 1.0;
        }
        return (longerLength - this.editDistance(longer, shorter)) / parseFloat(longerLength);
      },
      editDistance(s1, s2) {
        s1 = s1.toLowerCase();
        s2 = s2.toLowerCase();

        var costs = [];
        for (var i = 0; i <= s1.length; i++) {
          var lastValue = i;
          for (var j = 0; j <= s2.length; j++) {
            if (i === 0) {
              costs[j] = j;
            } else {
              if (j > 0) {
                var newValue = costs[j - 1];
                if (s1.charAt(i - 1) !== s2.charAt(j - 1)) {
                  newValue = Math.min(Math.min(newValue, lastValue), costs[j]) + 1;
                }
                costs[j - 1] = lastValue;
                lastValue = newValue;
              }
            }
          }
          if (i > 0) {
            costs[s2.length] = lastValue;
          }
        }
        return costs[s2.length];
      },
      saveNeueBbr() {
        this.bbrImport.forEach((item) => {
          if (item.aktivenBeitrag) {
            item.aktivenBeitrag = parseFloat(item.aktivenBeitrag.replace(",", ".")).toFixed(2);
          }
          if (item.cvBeitrag) {
            item.cvBeitrag = parseFloat(item.cvBeitrag.replace(",", ".")).toFixed(2);
          }
          if (item.ahvBeitrag) {
            item.ahvBeitrag = parseFloat(item.ahvBeitrag.replace(",", ".")).toFixed(2);
          }
          if (item.hbvBeitrag) {
            item.hbvBeitrag = parseFloat(item.hbvBeitrag.replace(",", ".")).toFixed(2);
          }
          if (!item.kontoinhaber) {
            item.kontoinhaber = item.vorname + " " + item.nachname;
          }
          if (item.receptionsdatum) {
            if (isNaN(item.receptionsdatum)) {
              let date = item.receptionsdatum;
              let parts = date.split(".");
              item.receptionsdatum = parts[2] + "-" + parts[1] + "-" + parts[0];
            }
          }
          if (item.geburtsdatum) {
            if (isNaN(item.geburtsdatum)) {
              let date = item.geburtsdatum;
              let parts = date.split(".");
              item.geburtsdatum = parts[2] + "-" + parts[1] + "-" + parts[0];
            }
          }
          if (item.philistrierungsdatum) {
            if (isNaN(item.philistrierungsdatum)) {
              let date = item.philistrierungsdatum;
              let parts = date.split(".");
              item.philistrierungsdatum = parts[2] + "-" + parts[1] + "-" + parts[0];
            }
          }
          if (item.mandatUnterschriftsdatum) {
            if (isNaN(item.mandatUnterschriftsdatum)) {
              let date = item.mandatUnterschriftsdatum;
              let parts = date.split(".");
              item.mandatUnterschriftsdatum = parts[2] + "-" + parts[1] + "-" + parts[0];
            }
          }
          if (item.letzterLastschrifteinzug) {
            if (isNaN(item.letzterLastschrifteinzug)) {
              let date = item.letzterLastschrifteinzug;
              let parts = date.split(".");
              item.letzterLastschrifteinzug = parts[2] + "-" + parts[1] + "-" + parts[0];
            }
          }
          const object = {
            anrede: item.anrede,
            briefanrede: item.briefanrede,
            titel: item.titel,
            nachname: item.nachname,
            vorname: item.vorname,
            geburtsdatum: item.geburtsdatum,
            studiengang: item.studiengang,
            adresse: item.adresse,
            plz: item.plz,
            ort: item.ort,
            land: item.land,
            telefon: item.telefon,
            handy: item.handy,
            email: item.email,
            urverbindung: item.urverbindung,
            zm: item.zm,
            receptionsdatum: item.receptionsdatum,
            philistrierungsdatum: item.philistrierungsdatum,
            status: item.status,
            leibvater: item.leibvater,
            rbonummer: item.rbonummer,
            chargen: item.chargen,
            aktivenBeitrag: item.aktivenBeitrag,
            cvBeitrag: item.cvBeitrag,
            hbvBeitrag: item.hbvBeitrag,
            ahvBeitrag: item.ahvBeitrag,
            iban: item.iban,
            bic: item.bic,
            kontoinhaber: item.kontoinhaber,
            mandatsreferenz: item.mandatsreferenz,
          };
          this.$firebase
            .firestore()
            .collection("vereine")
            .doc(this.$vars.verbindung)
            .collection("kontakte")
            .add(object)
            .then((key) => {
              console.log("erstellt");
            })
            .catch((error) => {
              console.log(error);
            });
        });
        this.bbrUpdate.forEach((item) => {
          if (item.item.aktivenBeitrag) {
            item.item.aktivenBeitrag = parseFloat(item.item.aktivenBeitrag.replace(",", ".")).toFixed(2);
          }
          if (item.item.cvBeitrag) {
            item.item.cvBeitrag = parseFloat(item.item.cvBeitrag.replace(",", ".")).toFixed(2);
          }
          if (item.item.ahvBeitrag) {
            item.item.ahvBeitrag = parseFloat(item.item.ahvBeitrag.replace(",", ".")).toFixed(2);
          }
          if (item.item.hbvBeitrag) {
            item.item.hbvBeitrag = parseFloat(item.item.hbvBeitrag.replace(",", ".")).toFixed(2);
          }
          if (!item.item.kontoinhaber) {
            item.item.kontoinhaber = item.item.vorname + " " + item.item.nachname;
          }
          if (item.item.receptionsdatum) {
            if (item.item.receptionsdatum.indexOf(".") !== -1) {
              let date = item.item.receptionsdatum;
              let parts = date.split(".");
              item.item.receptionsdatum = parts[2] + "-" + parts[1] + "-" + parts[0];
            }
          }
          if (item.item.geburtsdatum) {
            if (isNaN(item.item.geburtsdatum)) {
              let date = item.item.geburtsdatum;
              let parts = date.split(".");
              item.item.geburtsdatum = parts[2] + "-" + parts[1] + "-" + parts[0];
            }
          }
          if (item.item.philistrierungsdatum) {
            if (isNaN(item.item.philistrierungsdatum)) {
              let date = item.item.philistrierungsdatum;
              let parts = date.split(".");
              item.item.philistrierungsdatum = parts[2] + "-" + parts[1] + "-" + parts[0];
            }
          }
          console.log(item);
          if (item.item.mandatUnterschriftsdatum) {
            console.log(item.item.mandatUnterschriftsdatum);
            if (isNaN(item.item.mandatUnterschriftsdatum)) {
              let date = item.item.mandatUnterschriftsdatum;
              let parts = date.split(".");
              item.item.mandatUnterschriftsdatum = parts[2] + "-" + parts[1] + "-" + parts[0];
            }
            console.log(item.item.mandatUnterschriftsdatum);
          }
          if (item.item.letzterLastschrifteinzug) {
            if (isNaN(item.item.letzterLastschrifteinzug)) {
              let date = item.item.letzterLastschrifteinzug;
              let parts = date.split(".");
              item.item.letzterLastschrifteinzug = parts[2] + "-" + parts[1] + "-" + parts[0];
            }
          }
          const updateObj = {};
          Object.keys(item.item).forEach((key) => {
            if (item.item[key] !== undefined && item.item[key] !== "") {
              updateObj[key] = item.item[key];
            }
          });
          updateObj.id = item.id;
          this.$store.dispatch("bbrbbr/updateBbrData", updateObj);
          this.bbrNeu = [];
          this.showImportExport = false;
        });
      },
      close() {
        this.e1 = 1;
        this.bbrNeu = [];
        this.kontaktfelder = [];
        this.showImportExport = !this.showImportExport;
      },
      // ************************************************************
      // ************************************************************
      // PRINT alle Funktionen für den Druck
      // ************************************************************
      // ************************************************************
      print() {
        this.$vars.loading = true;
        switch (this.printData.radioKontakte) {
          case "allSelected":
            this.printData.kontakte = [];
            this.selected.forEach((item) => {
              this.printData.kontakte.push(this.$store.getters["bbrbbr/bbr"](item));
            });
            break;
          case "allStatus":
            this.printData.kontakte = [];
            this.printData.gruppen.forEach((gruppe) => {
              this.$store.getters["bbrbbr/bbrStatus"](gruppe).forEach((bbr) => {
                this.printData.kontakte.push(bbr);
              });
            });
            break;
          case "allBbrBbr":
            this.printData.kontakte = this.$store.getters["bbrbbr/nurBbrbbr"];
            break;
          case "all":
            this.printData.kontakte = this.$store.state.bbrbbr.bbrbbr;
            break;
        }
        switch (this.printData.druckelement) {
          case "mitgliederverzeichnis":
            this.printMitgliederverzeichnis();
            break;
          case "geburtstagsliste":
            this.printGeburtstagsliste();
            break;
          case "versandadressendina4":
            this.printVersanddressendina4();
            break;
          case "versandadressendina4mitAnschreiben":
            this.versandadressendina4mitAnschreiben();
            break;
          case "versandadressendinlang":
            this.printVersanddressendinlang();
            break;
        }
      },
      printMitgliederverzeichnis() {
        let geburtstage = [
          { monat: "Januar", geburtstage: [] },
          { monat: "Februar", geburtstage: [] },
          { monat: "März", geburtstage: [] },
          { monat: "April", geburtstage: [] },
          { monat: "Mai", geburtstage: [] },
          { monat: "Juni", geburtstage: [] },
          { monat: "Juli", geburtstage: [] },
          { monat: "August", geburtstage: [] },
          { monat: "September", geburtstage: [] },
          { monat: "Oktober", geburtstage: [] },
          { monat: "November", geburtstage: [] },
          { monat: "Dezember", geburtstage: [] },
        ];
        this.printData.kontakte.forEach((bbr) => {
          if (bbr.geburtsdatum) {
            bbr.geburtsmonat = bbr.geburtsdatum.split("-")[1].padStart(2, "0");
            bbr.geburtstag = bbr.geburtsdatum.split("-")[2].padStart(2, "0");
            geburtstage[bbr.geburtsmonat - 1].geburtstage.push({ tag: bbr.geburtstag, bbr: bbr });
          }
        });
        geburtstage.forEach((item) => {
          item.geburtstage.sort((a, b) => (a.tag > b.tag ? 1 : -1));
        });
        // let rechnung = item
        // let bbr = this.$store.getters['bbrbbr/bbr'](rechnung.bbrID)
        let doc = new JSPDF({
          orientation: "p",
          unit: "mm",
          format: "a5",
        });
        doc.setFont("Times");
        const settings = this.$store.getters["einstellungen/einstellung"]("allgemein");
        doc.setFillColor(settings.primary.rgba.r, settings.primary.rgba.g, settings.primary.rgba.b);
        doc.rect(0, 167, 210, 3, "F");
        doc.setFillColor(settings.secondary.rgba.r, settings.secondary.rgba.g, settings.secondary.rgba.b);
        doc.rect(0, 170, 210, 3, "F");
        doc.setFillColor(settings.tertiary.rgba.r, settings.tertiary.rgba.g, settings.tertiary.rgba.b);
        doc.rect(0, 173, 210, 3, "F");
        let img = new Image();
        img.src = "/static/" + this.$vars.verbindung + "/wappen_256.png";
        doc.addImage(img, 30, 28, 88, 88);
        doc.setFontSize(24);
        doc.text(settings.name, 74, 130, null, null, "center");
        doc.text("Mitgliederverzeichnis", 74, 145, null, null, "center");
        doc.setFontSize(11);
        doc.text(
          "Stand: " + new Date().toLocaleString(["de-de"], { month: "short", day: "2-digit", year: "numeric" }),
          74,
          155,
          null,
          null,
          "center"
        );
        doc.addPage();
        let zeile = 15;
        doc.setFontSize(20);
        doc.text("Geburtstagsliste", 74, zeile, null, null, "center");
        doc.setFontSize(11);
        zeile = zeile + 15;
        geburtstage.forEach((item) => {
          if (zeile > 190) {
            zeile = 15;
            doc.addPage();
          }
          doc.setFontSize(20);
          doc.text(item.monat, 12, zeile);
          doc.setFontSize(11);
          zeile = zeile + 8;
          item.geburtstage.forEach((bbr) => {
            if (zeile > 190) {
              zeile = 15;
              doc.addPage();
            }
            doc.text(
              new Date(bbr.bbr.geburtsdatum).toLocaleString(["de-de"], {
                month: "short",
                day: "2-digit",
                year: "numeric",
              }),
              12,
              zeile
            );
            if (bbr.bbr.titel) {
              doc.text(bbr.bbr.titel + " " + bbr.bbr.vorname + " " + bbr.bbr.nachname, 45, zeile);
            } else {
              doc.text(bbr.bbr.vorname + " " + bbr.bbr.nachname, 45, zeile);
            }
            zeile = zeile + 5;
          });
          zeile = zeile + 16;
        });
        doc.addPage();
        zeile = 15;
        doc.setFontSize(20);
        doc.text("Kontaktliste", 74, zeile, null, null, "center");
        doc.setFontSize(11);
        zeile = zeile + 15;
        this.printData.kontakte.forEach((bbr) => {
          if (zeile > 180) {
            zeile = 15;
            doc.addPage();
          }
          doc.setFontSize(11);
          doc.setFont("Times", "bold");
          if (bbr.titel) {
            doc.text(bbr.titel + " " + bbr.vorname + " " + bbr.nachname, 12, zeile);
          } else {
            doc.text(bbr.vorname + " " + bbr.nachname, 12, zeile);
          }
          doc.setFont("Times", "normal");
          doc.text(bbr.status, 12, zeile + 5);
          doc.text(bbr.adresse + " " + bbr.plz + " " + bbr.ort, 12, zeile + 10);
          if (bbr.telefon) {
            doc.text(bbr.telefon, 12, zeile + 15);
          }
          if (bbr.handy) {
            doc.text(bbr.handy, 12, zeile + 20);
          }
          if (bbr.email) {
            doc.text(bbr.email, 12, zeile + 25);
          }
          doc.setFontSize(9);
          if (bbr.geburtsdatum) {
            doc.text(
              "Geburtsdatum: " +
                new Date(bbr.geburtsdatum).toLocaleString(["de-de"], {
                  month: "short",
                  day: "2-digit",
                  year: "numeric",
                }),
              136,
              zeile + 5,
              null,
              null,
              "right"
            );
          }
          if (bbr.receptionsdatum) {
            doc.text(
              "Receptionsdatum: " +
                new Date(bbr.receptionsdatum).toLocaleString(["de-de"], {
                  month: "short",
                  day: "2-digit",
                  year: "numeric",
                }),
              136,
              zeile + 10,
              null,
              null,
              "right"
            );
          }
          if (bbr.philistrierungsdatum) {
            doc.text(
              "Philistrierungsdatum: " +
                new Date(bbr.philistrierungsdatum).toLocaleString(["de-de"], {
                  month: "short",
                  day: "2-digit",
                  year: "numeric",
                }),
              136,
              zeile + 15,
              null,
              null,
              "right"
            );
          }
          // if (bbr.urverbindung) { doc.text('Urverbindung: ' + bbr.urverbindung, 136, zeile + 20, null, null, 'right') }
          // if (bbr.zm) { doc.text('Bandverbindung: ' + bbr.zm, 136, zeile + 25, null, null, 'right', { maxWidth: 50 }) }
          zeile = zeile + 40;
        });
        doc.addPage();
        doc.setFontSize(11);
        doc.text("Der Inhalt dieser Publikation ist nur für Angehörige der", 74, 110, null, null, "center");
        doc.text(settings.name, 74, 115, null, null, "center");
        doc.text("bestimmt und Dritten nicht zugänglich zu machen.", 74, 120, null, null, "center");
        doc.text("Bei fehlerhaften Daten bitten wir um eine kurze Nachricht", 74, 130, null, null, "center");
        doc.text("an den Schriftführer unter xxx@kdstv-ripuaria.de.", 74, 135, null, null, "center");
        doc.addPage();
        doc.setFillColor(settings.primary.rgba.r, settings.primary.rgba.g, settings.primary.rgba.b);
        doc.rect(0, 167, 210, 3, "F");
        doc.setFillColor(settings.secondary.rgba.r, settings.secondary.rgba.g, settings.secondary.rgba.b);
        doc.rect(0, 170, 210, 3, "F");
        doc.setFillColor(settings.tertiary.rgba.r, settings.tertiary.rgba.g, settings.tertiary.rgba.b);
        doc.rect(0, 173, 210, 3, "F");
        doc.save(
          "Mitgliederverzeichnis " + new Date().toLocaleString(["de-de"], { month: "short", year: "numeric" }) + ".pdf"
        );
        this.$vars.loading = false;
      },
      printGeburtstagsliste() {
        let geburtstage = [
          { monat: "Januar", geburtstage: [] },
          { monat: "Februar", geburtstage: [] },
          { monat: "März", geburtstage: [] },
          { monat: "April", geburtstage: [] },
          { monat: "Mai", geburtstage: [] },
          { monat: "Juni", geburtstage: [] },
          { monat: "Juli", geburtstage: [] },
          { monat: "August", geburtstage: [] },
          { monat: "September", geburtstage: [] },
          { monat: "Oktober", geburtstage: [] },
          { monat: "November", geburtstage: [] },
          { monat: "Dezember", geburtstage: [] },
        ];
        this.printData.kontakte.forEach((bbr) => {
          if (bbr.geburtsdatum) {
            bbr.geburtsmonat = bbr.geburtsdatum.split("-")[1].padStart(2, "0");
            bbr.geburtstag = bbr.geburtsdatum.split("-")[2].padStart(2, "0");
            geburtstage[bbr.geburtsmonat - 1].geburtstage.push({ tag: bbr.geburtstag, bbr: bbr });
          }
        });
        geburtstage.forEach((item) => {
          item.geburtstage.sort((a, b) => (a.tag > b.tag ? 1 : -1));
        });
        let wintersemester = [];
        wintersemester = wintersemester.concat(geburtstage[9].geburtstage);
        wintersemester = wintersemester.concat(geburtstage[10].geburtstage);
        wintersemester = wintersemester.concat(geburtstage[11].geburtstage);
        wintersemester = wintersemester.concat(geburtstage[0].geburtstage);
        wintersemester = wintersemester.concat(geburtstage[1].geburtstage);
        wintersemester = wintersemester.concat(geburtstage[2].geburtstage);
        let sommersemester = [];
        sommersemester = sommersemester.concat(geburtstage[3].geburtstage);
        sommersemester = sommersemester.concat(geburtstage[4].geburtstage);
        sommersemester = sommersemester.concat(geburtstage[5].geburtstage);
        sommersemester = sommersemester.concat(geburtstage[6].geburtstage);
        sommersemester = sommersemester.concat(geburtstage[7].geburtstage);
        sommersemester = sommersemester.concat(geburtstage[8].geburtstage);
        let doc = new JSPDF({
          orientation: "p",
          unit: "mm",
          format: "a4",
        });
        doc.setFont("Times");
        const settings = this.$store.getters["einstellungen/einstellung"]("allgemein");
        doc.setFillColor(settings.primary.rgba.r, settings.primary.rgba.g, settings.primary.rgba.b);
        doc.rect(0, 90, 210, 1, "F");
        doc.setFillColor(settings.secondary.rgba.r, settings.secondary.rgba.g, settings.secondary.rgba.b);
        doc.rect(0, 91, 210, 1, "F");
        doc.setFillColor(settings.tertiary.rgba.r, settings.tertiary.rgba.g, settings.tertiary.rgba.b);
        doc.rect(0, 92, 210, 1, "F");
        let img = new Image();
        img.src = "/static/" + this.$vars.verbindung + "/wappen_256.png";
        doc.addImage(img, 125, 30, 75, 75);
        doc.setFontSize(9);
        doc.text(settings.name, 25, 87);
        doc.setFontSize(20);
        doc.text(
          "Geburtstagsliste Wintersemester " + new Date().toLocaleString(["de-de"], { year: "numeric" }),
          25,
          120
        );
        doc.setFontSize(11);
        doc.text(
          "Stand: " + new Date().toLocaleString(["de-de"], { month: "short", day: "2-digit", year: "numeric" }),
          185,
          110,
          null,
          null,
          "right"
        );
        let zeile = 130;
        doc.setFontSize(11);
        wintersemester.forEach((bbr) => {
          if (zeile > 272) {
            zeile = 25;
            doc.addPage();
          }
          doc.text(
            new Date(bbr.bbr.geburtsdatum).toLocaleString(["de-de"], {
              month: "short",
              day: "2-digit",
              year: "numeric",
            }),
            25,
            zeile
          );
          if (bbr.bbr.titel) {
            doc.text(bbr.bbr.titel + " " + bbr.bbr.vorname + " " + bbr.bbr.nachname, 65, zeile);
          } else {
            doc.text(bbr.bbr.vorname + " " + bbr.bbr.nachname, 65, zeile);
          }
          zeile = zeile + 5;
        });
        doc.addPage();
        doc.setFillColor(settings.primary.rgba.r, settings.primary.rgba.g, settings.primary.rgba.b);
        doc.rect(0, 90, 210, 1, "F");
        doc.setFillColor(settings.secondary.rgba.r, settings.secondary.rgba.g, settings.secondary.rgba.b);
        doc.rect(0, 91, 210, 1, "F");
        doc.setFillColor(settings.tertiary.rgba.r, settings.tertiary.rgba.g, settings.tertiary.rgba.b);
        doc.rect(0, 92, 210, 1, "F");
        img.src = "/static/" + this.$vars.verbindung + "/wappen_256.png";
        doc.addImage(img, 125, 30, 75, 75);
        doc.setFontSize(9);
        doc.text(settings.name, 25, 87);
        doc.setFontSize(20);
        doc.text(
          "Geburtstagsliste Sommersemester " + new Date().toLocaleString(["de-de"], { year: "numeric" }),
          25,
          120
        );
        doc.setFontSize(11);
        doc.text(
          "Stand: " + new Date().toLocaleString(["de-de"], { month: "short", day: "2-digit", year: "numeric" }),
          185,
          110,
          null,
          null,
          "right"
        );
        zeile = 130;
        doc.setFontSize(11);
        sommersemester.forEach((bbr) => {
          if (zeile > 272) {
            zeile = 25;
            doc.addPage();
          }
          doc.text(
            new Date(bbr.bbr.geburtsdatum).toLocaleString(["de-de"], {
              month: "short",
              day: "2-digit",
              year: "numeric",
            }),
            25,
            zeile
          );
          if (bbr.bbr.titel) {
            doc.text(bbr.bbr.titel + " " + bbr.bbr.vorname + " " + bbr.bbr.nachname, 65, zeile);
          } else {
            doc.text(bbr.bbr.vorname + " " + bbr.bbr.nachname, 65, zeile);
          }
          zeile = zeile + 5;
        });
        const year = new Date().toLocaleString(["de-de"], { year: "numeric" });
        doc.save("Geburtstagsliste WS + SS " + year + ".pdf");
        // doc.save('Geburtstagsliste.pdf')
        this.$vars.loading = false;
      },
      printVersanddressendina4() {
        let doc = new JSPDF({
          orientation: "p",
          unit: "mm",
          format: "a4",
        });
        doc.setFont("Times");
        this.printData.kontakte.forEach((bbr) => {
          doc.setFillColor(0, 0, 0);
          doc.rect(0, 104.9, 3, 0.2, "F");
          doc.rect(0, 148.4, 5, 0.2, "F");
          doc.rect(0, 209.9, 3, 0.2, "F");
          const settings = this.$store.getters["einstellungen/einstellung"]("allgemein");
          doc.setFillColor(settings.primary.rgba.r, settings.primary.rgba.g, settings.primary.rgba.b);
          doc.rect(0, 90, 210, 1, "F");
          doc.setFillColor(settings.secondary.rgba.r, settings.secondary.rgba.g, settings.secondary.rgba.b);
          doc.rect(0, 91, 210, 1, "F");
          doc.setFillColor(settings.tertiary.rgba.r, settings.tertiary.rgba.g, settings.tertiary.rgba.b);
          doc.rect(0, 92, 210, 1, "F");
          let img = new Image();
          img.src = "/static/" + this.$vars.verbindung + "/wappen_256.png";
          doc.addImage(img, 125, 30, 75, 75);
          doc.setFontSize(9);
          doc.text(
            settings.name +
              " | " +
              settings.strasse +
              " " +
              settings.hausnummer +
              " | " +
              settings.plz +
              " " +
              settings.ort,
            25,
            51
          );
          doc.setFontSize(11);
          var anrede = bbr.anrede === "Herr" ? "Herrn" : bbr.anrede || "";
          if (bbr.titel) {
            doc.text(anrede + " " + bbr.titel, 25, 61);
          } else {
            doc.text(anrede, 25, 61);
          }
          doc.text((bbr.vorname || "") + " " + (bbr.nachname || ""), 25, 66);
          doc.text(bbr.adresse || "", 25, 71);
          doc.text((bbr.plz || "") + " " + (bbr.ort || ""), 25, 76);
          doc.text(bbr.land || "", 25, 81);
          doc.addPage();
        });
        doc.save(
          "Versandadressen DIN A4 Brief " +
            new Date().toLocaleString(["de-de"], { month: "short", year: "numeric" }) +
            ".pdf"
        );
        this.$vars.loading = false;
      },
      versandadressendina4mitAnschreiben() {
        let doc = new JSPDF({
          orientation: "p",
          unit: "mm",
          format: "a4",
        });
        doc.setFont("Times");
        this.printData.kontakte.forEach((bbr, index) => {
          doc.setFillColor(0, 0, 0);
          doc.rect(0, 104.9, 3, 0.2, "F");
          doc.rect(0, 148.4, 5, 0.2, "F");
          doc.rect(0, 209.9, 3, 0.2, "F");
          const settings = this.$store.getters["einstellungen/einstellung"]("allgemein");
          doc.setFillColor(settings.primary.rgba.r, settings.primary.rgba.g, settings.primary.rgba.b);
          doc.rect(0, 90, 210, 1, "F");
          doc.setFillColor(settings.secondary.rgba.r, settings.secondary.rgba.g, settings.secondary.rgba.b);
          doc.rect(0, 91, 210, 1, "F");
          doc.setFillColor(settings.tertiary.rgba.r, settings.tertiary.rgba.g, settings.tertiary.rgba.b);
          doc.rect(0, 92, 210, 1, "F");
          let img = new Image();
          img.src = "/static/" + this.$vars.verbindung + "/wappen_256.png";
          doc.addImage(img, 125, 30, 75, 75);
          doc.setFontSize(9);
          doc.text(
            settings.name +
              " | " +
              settings.strasse +
              " " +
              settings.hausnummer +
              " | " +
              settings.plz +
              " " +
              settings.ort,
            25,
            51
          );
          doc.setFontSize(11);
          var anrede = bbr.anrede === "Herr" ? "Herrn" : bbr.anrede || "";
          if (bbr.titel) {
            doc.text(anrede + " " + bbr.titel, 25, 61);
          } else {
            doc.text(anrede, 25, 61);
          }
          doc.text((bbr.vorname || "") + " " + (bbr.nachname || ""), 25, 66);
          doc.text(bbr.adresse || "", 25, 71);
          doc.text((bbr.plz || "") + " " + (bbr.ort || ""), 25, 76);
          doc.text(bbr.land || "", 25, 81);
          doc.setFont("Times", "bold");
          if (this.printData.anschreibenTitel) {
            doc.text(this.printData.anschreibenTitel, 25, 110);
          }
          doc.setFont("Times", "normal");
          // Aufteilen des Textes in zwei Teile
          let maxLinesPerPage = this.printData.anschreibenTitel ? 35 : 38; // Anzahl der Zeilen, die auf eine Seite passen
          let lines = doc.splitTextToSize(this.printData.anschreiben, 160);
          let lines1 = lines.slice(0, maxLinesPerPage);
          let lines2 = lines.slice(maxLinesPerPage);
          // Schreiben des Textes auf die aktuelle Seite
          doc.setFont("Times", "normal");
          // console.log(this.printData.anschreiben)
          // doc.text(this.printData.anschreiben, 25, this.printData.anschreibenTitel ? 125 : 110, { align: 'justify', maxWidth: '160' })
          doc.text(lines1, 25, this.printData.anschreibenTitel ? 125 : 110);
          // Wenn es noch mehr Text gibt, eine neue Seite hinzufügen und den Rest des Textes darauf schreiben
          if (lines2.length > 0) {
            doc.addPage();
            doc.setFont("Times", "normal");
            doc.text(lines2, 25, 30);
          }
          if (index + 1 < this.printData.kontakte.length) {
            doc.addPage();
          }
        });
        doc.save(
          "Versandadressen DIN A4 Brief " +
            new Date().toLocaleString(["de-de"], { month: "short", year: "numeric" }) +
            ".pdf"
        );
        this.$vars.loading = false;
      },
      printVersanddressendinlang() {
        let doc = new JSPDF({
          orientation: "p",
          unit: "mm",
          format: "a4",
        });
        doc.setFont("Times");
        let zeile = -20;
        doc.setFillColor(0, 0, 0);
        doc.rect(0, 98.9, 3, 0.2, "F");
        doc.rect(0, 197.9, 3, 0.2, "F");
        const settings = this.$store.getters["einstellungen/einstellung"]("allgemein");
        this.printData.kontakte.forEach((bbr) => {
          doc.setFillColor(settings.primary.rgba.r, settings.primary.rgba.g, settings.primary.rgba.b);
          doc.rect(0, zeile + 90, 210, 1, "F");
          doc.setFillColor(settings.secondary.rgba.r, settings.secondary.rgba.g, settings.secondary.rgba.b);
          doc.rect(0, zeile + 91, 210, 1, "F");
          doc.setFillColor(settings.tertiary.rgba.r, settings.tertiary.rgba.g, settings.tertiary.rgba.b);
          doc.rect(0, zeile + 92, 210, 1, "F");
          let img = new Image();
          img.src = "/static/" + this.$vars.verbindung + "/wappen_256.png";
          doc.addImage(img, 125, zeile + 30, 75, 75);
          doc.setFontSize(9);
          doc.text(
            settings.name +
              " | " +
              settings.strasse +
              " " +
              settings.hausnummer +
              " | " +
              settings.plz +
              " " +
              settings.ort,
            25,
            zeile + 51
          );
          doc.setFontSize(11);
          var anrede = bbr.anrede === "Herr" ? "Herrn" : bbr.anrede;
          if (bbr.titel) {
            doc.text(anrede + " " + bbr.titel, 25, zeile + 61);
          } else {
            doc.text(anrede, 25, zeile + 61);
          }
          doc.text(bbr.vorname + " " + bbr.nachname, 25, zeile + 66);
          doc.text(bbr.adresse, 25, zeile + 71);
          doc.text((bbr.plz || "") + " " + (bbr.ort || ""), 25, zeile + 76);
          doc.text(bbr.land, 25, zeile + 81);
          zeile = zeile + 99;
          if (zeile === 277) {
            zeile = -20;
            doc.addPage();
            doc.setFillColor(0, 0, 0);
            doc.rect(0, 98.9, 3, 0.2, "F");
            doc.rect(0, 197.9, 3, 0.2, "F");
          }
        });
        doc.save(
          "Versandadressen DIN Lang Brief " +
            new Date().toLocaleString(["de-de"], { month: "short", year: "numeric" }) +
            ".pdf"
        );
        this.$vars.loading = false;
      },
      savereihenfolge() {
        let saveheaders = this.$store.getters["einstellungen/einstellung"]("kontaktspalten");
        saveheaders[this.currentBbr] = this.selectHeaders;
        this.$store.dispatch("einstellungen/updateEinstellungData", saveheaders);
      },
    },
    mounted() {
      this.setSelectedGruppeBbrBbr();
    },
  };
</script>

<style scoped>
  .v-expansion-panel:before {
    box-shadow: none !important;
  }
</style>



// WEBPACK FOOTER //
// kontakte.vue?42e6781e